
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gaB2il2KGrl_45AHGAJ6Pj4Xv2ig2ih_w0SkPA5YntPQ_45YMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexR8CMEzoSZ7t9cVIMoEkuR9TVr4LJlp1h_1zxY1__i_45YMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchuJgwGdBPCKM9EsJ7Bn0GDZvRr4DRaSnrqaleak9bGHsMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexa9DkBTkJT7cE3uI9aGBkZNt2Ne0U0rL_45lHH_45vqLNTWkMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93nmOY2LbHP7gT8UvknRRpuTouSMmqvb3_SV7VJYYB_45QwMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7nKPMjwE7Vs_Cfy7pJ3Dp6S9SpWxC2wMPCE0FgU7WskMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93G5PrVi9PAOK8Y3TZ5F0XH_45bxUUXwCWje2d3EfaXSJvEMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index04OVZ56fbeYEY_jPeQ58Wz5q4CM6dC097lvNXtUPJLgMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93sFElQXfG1y82P3YHqppFwCOFjTo8Hyf5aYJ23awg0YUMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexOfkM7EmhEsJ6hnscVqUVwV_45Nx4pyYvdcaFoBZEHR2BkMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexf0_45_45zgEkEI_459ZbbLW_45pIsWl7owMSkq_45heYbaYFvibzwMeta } from "/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7nKPMjwE7Vs_Cfy7pJ3Dp6S9SpWxC2wMPCE0FgU7WskMeta || {},
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index04OVZ56fbeYEY_jPeQ58Wz5q4CM6dC097lvNXtUPJLgMeta || {},
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexOfkM7EmhEsJ6hnscVqUVwV_45Nx4pyYvdcaFoBZEHR2BkMeta || {},
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexf0_45_45zgEkEI_459ZbbLW_45pIsWl7owMSkq_45heYbaYFvibzwMeta || {},
    component: () => import("/codebuild/output/src1273456723/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]